<div class="blk-cont">
  <div class="blk-header">
    <span class="blk-title" i18n>Sign In</span>
    <tui-svg class="blk-icon" [src]="'mat::unlock'"></tui-svg>
  </div>
  <div class="blk-body">
    <form (ngSubmit)="login()" class="w-100">
      <div class="row my-2">
        <div class="col-12 text-center">
          <tui-input
            [(ngModel)]="email"
            tuiTextfieldSize="l"
            [tuiTextfieldLabelOutside]="true"
            name="email"
            i18n
          >
            Your email
            <input autocomplete="email" tuiTextfield type="email" />
          </tui-input>
        </div>
      </div>
      <div class="row my-2">
        <div class="col-12 text-center">
          <tui-input-password
            [(ngModel)]="password"
            tuiTextfieldSize="l"
            [tuiTextfieldLabelOutside]="true"
            name="password"
            i18n
          >
            Your password
            <input tuiTextfield />
          </tui-input-password>
        </div>
      </div>
      <div class="row my-4">
        <div class="col-12 d-flex justify-content-end align-items-center">
          <a class="me-auto" [routerLink]="['/password-reset']" i18n>Forgot your password?</a>
          <button type="submit" class="mbtn primary-500 ms-3">
            <tui-svg [src]="'mat::unlock'"></tui-svg>
            <ng-container i18n>Sign In</ng-container>
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
